import React from "react";
import {
    Button,
    Heading,
    Link, Project, Puffs
} from "arwes"
import {Trans} from "react-i18next";
import {useNavigate} from "react-router-dom";

const News = () => {


    return(
        <div >
            <Puffs>
            <div className="col-xs-12 col-md-12 col-lg-12">

                <div className="row">
                    <Project
                        className=""
                        animate
                        header="Science Fiction News"
                    >
                        { anim => (
                            <p ><Trans>
                                Science fiction is not only about cinema and here are some tools you use every day that got inspiration from Science Fiction
                            </Trans>
                                <br/> <br/>
                            <Link href="https://www.space.com/science-fiction-turned-reality.html" target="_blank" rel="noopener noreferrer">    <Button align="center"  animate><Trans>Read More</Trans></Button></Link>
                            </p>
                        )}
                    </Project>




                </div>

            </div>



            </Puffs>

        </div>
    )
}

export default News